import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import 'react-dates/initialize';
import { SingleDatePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import moment from 'moment';
import { range } from 'lodash';

export class DatePicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      focused: false,
    };
  }

  handleChange = (date) => {
    if (this.props.onChange && date) {
      this.props.onChange(date._d);
    }
  };

  render() {
    const { label, inline, placeholder = '', wrapperClassName = '', value } = this.props;
    return (
      <div className={`${wrapperClassName} ${inline ? 'datepicker-wrapper--inline' : 'datepicker-wrapper--block'}`}>
        <span className="datepicker-label">{label}</span>
        <SingleDatePicker
          date={moment(value)}
          placeholder={placeholder}
          startDateId="startDateId"
          onDateChange={this.handleChange}
          focused={this.state.focused}
          onFocusChange={({ focused }) => this.setState({ focused })}
          // showClearDate
          className="airbnb-SDP"
          withPortal
          autoFocus
          readOnly
          displayFormat="YYYY/MM/DD"
          showDefaultInputIcon
          inputIconPosition="before"
          renderMonthElement={({ month, onMonthSelect, onYearSelect }) => (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div>
                <select
                  value={month.month()}
                  onChange={(e) => { onMonthSelect(month, e.target.value); }}
                  className="datepicker-dropdown"
                >
                  {moment.months().map((label, value) => ( // eslint-disable-line no-shadow
                    <option className="datepicker-listitem" value={value}>{label}</option>
                  ))}
                </select>
              </div>
              <div>
                <select
                  value={month.year()}
                  onChange={(e) => { onYearSelect(month, e.target.value); }}
                  className="datepicker-dropdown"
                >
                  {
                    range(15).map((year, i) => (
                      <option className="datepicker-listitem" value={moment().year() - i}>{moment().year() - i}</option>
                    ))
                  }
                </select>
              </div>
            </div>
          )}
          numberOfMonths={1}
          isOutsideRange={() => false}
        />
      </div>
    );
  }
}

export default DatePicker;
